module.exports = __webpack_public_path__ + "img/truck-icon-01.9eccd2b3.gif";